<script setup lang="ts">
import CGeneratorModal from '../modals/GeneratorModal.vue';
import AiImage from '@/assets/ai/ai-image.png';
import type { FolderPermissions } from '#layers/core/app/components/filemanager/types';
import Permissions from '#layers/aicore/shared/permissions';

const props = defineProps<{
    cropper: boolean;
    permissions: FolderPermissions;
}>();

const emit = defineEmits<{
    (e: 'reload'): void;
}>();

const rwd = useMedia();
const aiStore = useAiSettingsStore();
const { filemanagerData } = useFilemanagerStore();
const { $permissions } = usePermissions();

const generatorModalRef = ref<any>(null);
const imageGeneratorCanAccess = ref<boolean>(false);

const aiEnabled = computed(() => aiStore.aiEnabled && imageGeneratorCanAccess.value);

const showGeneratorButton = computed(() => !props.cropper && props.permissions.canEdit);

onMounted(async (): Promise<void> =>
{
    imageGeneratorCanAccess.value = await $permissions.all([Permissions.AiCore.ImageGenerator.Access]);
});

function reload()
{
    emit('reload');
}
</script>

<template>
    <template v-if="!aiEnabled && rwd.desktop()">
        <div id="ai-generator-button" class="me-1">
            <ActionButton
                v-show="showGeneratorButton"
                disabled
                variant="fancy"
                icon="far fa-microchip-ai"
                :text="$t('[[[Generuj obraz]]]')"
                @click.prevent="generatorModalRef.showModal()"
            />
        </div>
        <IdeoPopover
            class="popover popover-ai-hint"
            placement="bottom"
            target="ai-generator-button"
            triggers="hover"
            :shadow="false"
            :rounded="true"
        >
            <div>
                <img :src="AiImage" class="w-100" alt="...">

                <div class="p-3">
                    <div class="fs-5 mb-1 fw-bolder">
                        {{ $t('[[[Wybróbuj możliwości AI]]]') }}
                    </div>

                    <div class="fs-6 mb-3">
                        {{ $t('[[[Przejdź do konfiguracji, aby włączyć narzędzia]]]') }}
                        <b>{{ $t('[[[Asystenta AI]]]') }}</b>.
                    </div>

                    <ActionButton variant="fancy" icon="far fa-microchip-ai" :text="$t('[[[Konfiguracja asystenta ai]]]')" :to="{ name: 'ai-settings' }" />
                </div>
            </div>
        </IdeoPopover>
    </template>
    <ActionButton
        v-show="aiEnabled && showGeneratorButton"
        variant="fancy"
        icon="far fa-microchip-ai"
        :text="$t('[[[Generuj obraz]]]')"
        @click.prevent="generatorModalRef.showModal()"
    />
    <CGeneratorModal
        v-show="aiEnabled && showGeneratorButton"
        ref="generatorModalRef"
        :scope="filemanagerData.scope"
        :folder="filemanagerData.folder"
        :pricing="null"
        @reload="reload"
    />
</template>
